import { useContext } from "react";

import { SellingPlansContext } from "../contexts/SellingPlansContext";

const useSellingPlansContext = () => {
  const context = useContext(SellingPlansContext);

  if (!context) throw new Error("Selling Plans context must be use inside Provider");

  return context;
};

export default useSellingPlansContext;
